<h1 mat-dialog-title>{{ "settings" | transloco }}</h1>
<mat-divider></mat-divider>
<mat-dialog-content [formGroup]="settingsForm">
    <div>
        <mat-checkbox formControlName="coloredTableButtons">{{ "colored_table_buttons" | transloco }}</mat-checkbox>
    </div>
    <div>
        <mat-checkbox formControlName="frostedGlass">{{ "frosted_glass" | transloco }}</mat-checkbox>
    </div>
    <div>
        <mat-checkbox formControlName="showCountdownTimer">{{ "show_countdown_timer" | transloco }}</mat-checkbox>
    </div>
    <div class="pixl-language-switcher"><pixl-language-switcher></pixl-language-switcher>&nbsp;{{ "language" | transloco
        }}</div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions>
    <button
        mat-raised-button
        (click)="onCancel()"
    >{{ "abort" | transloco }}</button>
    <button
        mat-raised-button
        (click)="onSave()"
    >{{ "save" | transloco }}</button>
</mat-dialog-actions>